import styled from 'styled-components'

import { breakpoints } from '@/styles'

import Floorplan from './floorplan'

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto 40px;
  flex-wrap: wrap;
  transition: max-height 0.2s ease-in-out;
  overflow: hidden;
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex-wrap: nowrap;
    margin-bottom: ${props => (props.expanded ? '40px' : '-80px')};
    max-height: ${props => (props.expanded ? '2900px' : '1200px')};
  }
`

const Floorplans = ({ floorplans = [], expanded }) => {
  const mappedFloorplans = floorplans?.map((floorplan = {}) => (
    <Floorplan
      image={floorplan.image}
      plan={floorplan.plan}
      bed={floorplan.bed}
      bath={floorplan.bath}
      link={`https://liv.rent/building/4517/w2-living-apartment-building-1988-wylie-st-vancouver-bc`}
      key={floorplan.plan}
      hasDen={floorplan.hasDen}
    />
  ))

  return <Container expanded={expanded}>{mappedFloorplans}</Container>
}

export default Floorplans
